import { OverlaySpinner } from '@ankr.com/ui';
import { Navigate } from 'react-router';
import loadable from '@loadable/component';

import { LoggingInGuard } from 'modules/auth/components/LoggingInGuard';
import { NoSSRGuard } from 'modules/common/components/NoSSRGuard';
import { Page } from 'modules/layout/components/Page';
import { teamsRoutesConfig } from 'domains/teams/routes';
import { useIsAccountCreationAllowedQuery } from 'modules/teamAccount/actions/hooks/useIsAccountCreationAllowedQuery';

const NewTeamPage = loadable(
  async () => {
    const module = await import('./NewTeamPage');

    return module.NewTeamPage;
  },
  {
    fallback: <OverlaySpinner />,
  },
);

const teamsPath = teamsRoutesConfig.teams.generatePath();

function NewTeamPageLoader() {
  const { isAccountCreationAllowed, loading: isAccountCreationAllowedLoading } =
    useIsAccountCreationAllowedQuery();

  if (isAccountCreationAllowedLoading) {
    return <OverlaySpinner />;
  }

  if (!isAccountCreationAllowed) {
    return <Navigate to={teamsPath} />;
  }

  return <NewTeamPage />;
}

export const NewTeamPageContainer = () => {
  return (
    <Page>
      <NoSSRGuard>
        <LoggingInGuard fallback={<Navigate to={teamsPath} />}>
          <NewTeamPageLoader />
        </LoggingInGuard>
      </NoSSRGuard>
    </Page>
  );
};
